import React, { useState } from 'react';
import axios from "axios";
import helpers from "@/utils/helpers";
import Modal from '../Modal';
import { RideButton, RideGlDownloadSolid, RideGlMailSolid } from '@rimac-seguros/ride-system-components';
import { Regex } from '@/utils/regex';

const Download = ({ props, data }) => {

    const { plateFormat, urlConstElect, numDoc, plate, typeDoc } = data;

    const { modal } = props;

    const [ activeModal, setActiveModal ] = useState(false);
    const [ loadingSpin, setLoadingSpin ] = useState(false);
    const [ loadingModal, setLoadingModal ] = useState(false);
    const [ modalCorreoInput, setModalCorreoInput ] = useState(false);

    const [titleModal, setTitleModal] = useState('');
    const [subtitleModal, setSubtitleModal] = useState('');
    const [iconModal, setIconModal] = useState('');
    const [buttonModal, setButtonModal] = useState('');

    const marcacionBtn = (label) => {
        helpers.setActionTag({
            group: 'Consulta SOAT',
            category: 'Resultado',
            action: 'Cliente RIMAC',
            label, 
        });
    };

    const replaceText = (text) => {
      return text ? text.replace("[placa]", plateFormat) : '';
    };

    const contentModal = (content) => {
        setTitleModal('');
        setSubtitleModal('');
        setButtonModal('');
        setIconModal('');

        let icon = '';
        let title = '';
        let subtitle = '';
        let buttonText = '';

        const { open, success, errorEmail, errorDownload} = modal;

        switch (content) {
            case 'MODAL_EMAIL':
                title = open?.title;
                subtitle = open?.subtitle && replaceText(open?.subtitle);
                break;

            case 'MODAL_EMAIL_SUCESS':
                icon = success?.icon;
                title = success?.title;
                subtitle = success?.subtitle;
                buttonText = "De acuerdo";
                break;

            case 'MODAL_EMAIL_ERROR':
                icon = errorEmail?.icon;
                title = errorEmail?.title;
                subtitle = errorEmail?.subtitle;
                buttonText = "De acuerdo";
                break;

            case 'MODAL_DOWNLOAD_ERROR':
                icon = errorDownload?.icon;
                title = errorDownload?.title;
                subtitle = errorDownload?.subtitle;
                buttonText = "De acuerdo";
                break;

            default:
              icon = '';
              title = '';
              subtitle = '';
              buttonText = '';
        };

        setIconModal(icon);
        setTitleModal(title);
        setSubtitleModal(subtitle);
        setButtonModal(buttonText);
    };
    
    const handleDownload = async () => {
        marcacionBtn('Descargar')
        setLoadingSpin(true);
        const envioCorreo = 'N';

        const result = await requestDownload(envioCorreo)
        
        if (result) {
            setLoadingSpin(false);
            download(urlConstElect);
        } else {
            setActiveModal(true)
            contentModal('MODAL_DOWNLOAD_ERROR')
        }
    };

    const download = async (url) => {
        await axios({
          url,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.target = "_blank";
          console.log('li')
          link.setAttribute("download", "certificado-electronico-SOAT.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    };
    
    const handleSendMail = async (email) => {
        const envioCorreo = 'S';
        marcacionBtn('Enviar por correo')
        setActiveModal(true)
        if (email && Regex.email.test(email)) {
            setLoadingModal(true)
            const result = await requestDownload(envioCorreo, email)
            if (result && urlConstElect) {
                contentModal('MODAL_EMAIL_SUCESS')
                setModalCorreoInput(false)
            } else {
                contentModal('MODAL_EMAIL_ERROR')
                setModalCorreoInput(false)
            }
        }
    };

    const openModalMail = () => {
        setModalCorreoInput(true)
        setActiveModal(true)
        contentModal('MODAL_EMAIL')
    };

    const requestDownload = async (indEnvioCorreo, email) => {
        let payload = {
            correo: email || '',
            idTransaccion: "",
            tipoDocumento: typeDoc,
            numeroDocumento: numDoc,
            indEnvioCorreo,
            placa: plate,
            telefono: ""
        }
        const response = await props.getDataConsultSoatPrint(payload);
        return response;
    };

    const closeModal = () => {
        setModalCorreoInput(false)
        setActiveModal(false)
        setLoadingSpin(false)
        setLoadingModal(false)
    }

    return (
        <>
            <div className="flex items-center gap-ride-gl-spacing-4xlarge mb-ride-gl-spacing-6xlarge lg:mb-0">
                <RideButton
                    text="Descargar"
                    loading={loadingSpin}
                    glyph={<RideGlDownloadSolid key="RideGlDownloadSolid" />}
                    glyphPosition="left"
                    variant="outline"
                    size="small"
                    onClick={handleDownload}
                />
                <RideButton
                    text="Enviar por correo"
                    variant="text-primary"
                    glyph={<RideGlMailSolid size="small" />}
                    glyphPosition="left"
                    size="medium"
                    className="text-left"
                    onClick={openModalMail}
                />
            </div>
            {
              (data && activeModal) &&
                <Modal
                  isOpen={activeModal}
                  icon={iconModal}
                  title={titleModal}
                  subtitle={subtitleModal}
                  button={buttonModal}
                  closeModal={closeModal}
                  viewForm={modalCorreoInput}
                  handleSendMail={handleSendMail}
                  loadingModal={loadingModal}
                />
            }
        </>
    );
}

export default Download;